declare var gsap: any;
declare var ScrollTrigger: any;

const environmentgallery = () => {
  const gallery = document.querySelector('.js-envi-gallery');
  const slider = document.querySelector('.js-envi-gallery-slider');

  if (!gallery || !slider) return;
  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.refresh();

  const items = slider.querySelectorAll('.js-envi-gallery-item');
  let totalWidth = 0;
  let itemwwidth = 0;
  items.forEach((element) => {
    itemwwidth = element.clientWidth;
    totalWidth += element.clientWidth;
  });

  let slideto = 0;

  if (window.innerWidth <= 767) {
    gsap.set(slider, { x: '5.83%' });
    slideto = totalWidth + itemwwidth / 2;
  } else {
    gsap.set(slider, { x: '40%' });
    slideto = totalWidth - itemwwidth * 1.4;
  }

  gsap.to(slider, {
    x: () => -slideto,
    ease: 'linear',
    scrollTrigger: {
      trigger: gallery,
      pin: true,
      scrub: 1,
      start: 'top top',
      end: () => `+=${totalWidth}`,
    },
  });

  window.addEventListener('load', () => {
    ScrollTrigger.refresh();
  });

  window.addEventListener('resize', () => {
    ScrollTrigger.refresh();
  });
};

export default environmentgallery;
